<template>
    <div class="login">
        <TopNavBar navtitle="用户注册"></TopNavBar>
        <div class="logoimg">
            <img src="../assets/gzmalogo.png" alt="">
            <van-icon class="iconfont" class-prefix='icon' name='icon-biaoqian' />
        </div>
        <div class="login-box">
            <van-form @submit="onSubmit">
                <van-field v-model="Mobile" name="Mobile" :left-icon="require('@/assets/rmobile.png')" label=" " placeholder="请填写手机号" />
                <!-- <van-field v-model="smscode" name="code" center clearable :left-icon="require('@/assets/rcode.png')" label=" " placeholder="请输入短信验证码">
                    <template #button>
                        <van-button v-if="showGetCode" style="width:78px" size="small" native-type="button" type="primary" @click="SendCode">发送验证码</van-button>
                        <van-button v-if="!showGetCode" style="width:78px" size="small" native-type="button" type="primary" @click="$toast.fail('请勿重复提交')">{{second}}</van-button>
                    </template>
                </van-field> -->
                <van-field v-model="password" type="password" name="pwd" label=" " :left-icon="require('@/assets/rpossword.png')" placeholder="请输入密码" />
                <van-field v-model="rpassword" type="password" name="rpwd" label=" " :left-icon="require('@/assets/rpossword.png')" placeholder="请确认密码" />
                <div class="regbtn-box">
                    <van-button round block type="info" class="regbtn" native-type="submit">
                        <img src="../assets/loginuser.png" width="25px" alt="">立即注册
                    </van-button>
                </div>
            </van-form>
            <div class="find-box">
                <span>
                    <router-link to="/"></router-link>
                </span>
                <span>
                    已有账号?<router-link to="/login">请登录</router-link>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import TopNavBar from '@/components/TopNavBar.vue'
import { SendSMSCode, UserExists } from "@/api/public";
import { GetWeiXinUserInfo } from "@/api/weixin";
import { UserRegister } from "@/api/login";
import { setToken, setNickName, setHeadImg, setMobile } from '@/Utils/auth'
const defaultWeiXinUserInfo = {
    openid: "",
    nickname: "",
    sex: "",
    province: "",
    city: "",
    country: "",
    headimgurl: ""
}
const defaultUserInfo = {
    Mobile: '',
    Name: '',
    Pwd: '',
    OpenID: '',
    NickName: '',
    HeadImgurl: '',
    Sex: ''

}
export default {
    components: {
        TopNavBar
    },
    data () {
        return {
            Mobile: '',
            smscode: 'gzma@123',
            code: '',
            password: '',
            rpassword: '',
            showGetCode: true,
            second: 60,
            WeiXinUserInfo: null,
            CheckCode: ''
        };
    },
    mounted () {
        this.getCode();
    },
    methods: {
        onSubmit (values) {
            if (values.Mobile === '') {
                this.$toast.fail({ message: '请输入手机号', });
                return;
            }
            if (values.smscode === '') {
                this.$toast.fail({ message: '请输入验证码', });
                return;
            }
            if (values.pwd === '' || values.pwd == undefined) {
                this.$toast.fail({ message: '请输入密码', });
                return;
            }
            if (values.rpwd === '' || values.rpwd == undefined) {
                this.$toast.fail({ message: '请输入确认密码', });
                return;
            }
            if (values.pwd !== values.rpwd) {
                this.$toast.fail({ message: '两次输入的密码不一致', });
                return;
            }
            let userinfo = Object.assign({}, defaultUserInfo);
            userinfo.Mobile = values.Mobile;
            userinfo.Name = this.WeiXinUserInfo.nickname;
            userinfo.Pwd = values.pwd;
            userinfo.OpenID = this.WeiXinUserInfo.openid;
            userinfo.NickName = userinfo.Name;
            userinfo.HeadImgurl = this.WeiXinUserInfo.headimgurl;
            let Sex = '未知';
            if (this.WeiXinUserInfo.sex == 1) {
                Sex = '男';
            } else if (this.WeiXinUserInfo.sex == 2) {
                Sex = '女';
            }
            userinfo.Sex = Sex;
            localStorage.clear();
            UserRegister({ code: this.smscode }, userinfo).then(response => {
                const tokenStr = response.OtherMsg.TokenHead + ' ' + response.OtherMsg.Token;
                setToken(tokenStr);
                setNickName(response.OtherMsg.NickName);
                setHeadImg(response.OtherMsg.HeadImg);
                setMobile(response.OtherMsg.Mobile);

                this.$toast.success({ message: '注册成功正在跳转至会员中心', });
                this.$router.push({ path: '/VipCenter' });
            });
        },
        SendCode () {
            if (this.Mobile === '') {
                this.$toast.fail({ message: '请输入手机号', });
                return;
            }
            if (this.CheckCode === '') {
                this.$toast.fail({ message: '校验码不正确', });
                return;
            }
            UserExists({ Mobile: this.Mobile }).then(response => {
                if (response.OtherMsg.IsExists == "1") {
                    this.$toast.fail({ message: '该手机号已被使用', });
                    return;
                }

                SendSMSCode({ Mobile: this.Mobile, CheckCode: this.CheckCode,OpenID:this.WeiXinUserInfo.openid }).then(res => {
                    this.$toast.success({ message: '验证码已发送', });
                    const TIME_COUNT = 120;
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.showGetCode = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.showGetCode = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                    return;
                });
            });
        },
        getCode () { // 非静默授权，第一次有弹框
            this.code = '';
            var local = window.location.href;
            var appid = process.env.VUE_APP_WEIXIN_APPID
            this.code = this.getUrlCode().code // 截取code
            if (this.code == null || this.code === '') { // 如果没有code，则去请求
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
            } else {
                GetWeiXinUserInfo({ code: this.code }).then(response => {
                    this.WeiXinUserInfo = Object.assign({}, response.item);
                    this.CheckCode = response.OtherMsg.CheckCode;
                }).catch(() => {
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
                });
            }
        },
        getUrlCode () { // 截取url中的code方法
            var url = location.search
            this.winUrl = url
            var theRequest = new Object()
            if (url.indexOf("?") != -1) {
                var str = url.substr(1)
                var strs = str.split("&")
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
                }
            }
            return theRequest
        }
    },
}
</script>
<style scoped>
</style>
